import OrbitApiV1 from '.'

class TicketAPI {
  static getTicketTypes() {
    return OrbitApiV1.httpGet(`/tickets/get/ticketTypes`)
  }

  static getTickets(limit = '', query = '', details = 1) {
    return OrbitApiV1.httpGet(
      `/tickets/get?limit=${limit}&query=${query}&details=${details}`
    )
  }

  static createTicket(ticket) {
    return OrbitApiV1.httpPost(`/tickets/create`, {}, ticket)
  }

  static updateTicket(ticket) {
    return OrbitApiV1.httpPut(`/tickets/update`, {}, ticket)
  }
}

export default TicketAPI
